import { Form, Col, Row } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchProvinces,
  fetchWards,
} from '../../../store/actions/address.action';
import { useTranslation } from 'react-i18next';
import InputComponent from '../InputComponent/InputComponent';
import SelectComponent from '../SelectComponent/SelectComponent';
import CheckboxComponent from '../CheckboxComponent/CheckboxComponent';
import { useEffect } from 'react';

const FormAddress = ({ form }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { provinces, wards } = useSelector(state => state.address);

  const provinceId = Form.useWatch('city', form);

  const fixedProvince = {
    province_id: 2,
    code: 'ADM1-79',
    name: 'Thành phố Hồ Chí Minh',
  };
  const newWardsHCM = [
    { wards_id: 49289, name: 'Phường An Hội Tây', province_id: 2 },
    { wards_id: 49290, name: 'Phường An Hội Đông', province_id: 2 },
    { wards_id: 49231, name: 'Phường An Khánh', province_id: 2 },
    { wards_id: 49282, name: 'Phường An Lạc', province_id: 2 },
    { wards_id: 49286, name: 'Phường An Nhơn', province_id: 2 },
    { wards_id: 49272, name: 'Phường An Phú Đông', province_id: 2 },
    { wards_id: 49246, name: 'Phường An Đông', province_id: 2 },
    { wards_id: 49239, name: 'Phường Bàn Cờ', province_id: 2 },
    { wards_id: 49279, name: 'Phường Bình Hưng Hoà', province_id: 2 },
    { wards_id: 49275, name: 'Phường Bình Lợi Trung', province_id: 2 },
    { wards_id: 49250, name: 'Phường Bình Phú', province_id: 2 },
    { wards_id: 49277, name: 'Phường Bình Quới', province_id: 2 },
    { wards_id: 49274, name: 'Phường Bình Thạnh', province_id: 2 },
    { wards_id: 49266, name: 'Phường Bình Thới', province_id: 2 },
    { wards_id: 49248, name: 'Phường Bình Tiên', province_id: 2 },
    { wards_id: 49232, name: 'Phường Bình Trưng', province_id: 2 },
    { wards_id: 49281, name: 'Phường Bình Trị Đông', province_id: 2 },
    { wards_id: 49278, name: 'Phường Bình Tân', province_id: 2 },
    { wards_id: 49249, name: 'Phường Bình Tây', province_id: 2 },
    { wards_id: 49258, name: 'Phường Bình Đông', province_id: 2 },
    { wards_id: 49297, name: 'Phường Bảy Hiền', province_id: 2 },
    { wards_id: 49236, name: 'Phường Bến Thành', province_id: 2 },
    { wards_id: 49257, name: 'Phường Chánh Hưng', province_id: 2 },
    { wards_id: 49247, name: 'Phường Chợ Lớn', province_id: 2 },
    { wards_id: 49245, name: 'Phường Chợ Quán', province_id: 2 },
    { wards_id: 49233, name: 'Phường Cát Lái', province_id: 2 },
    { wards_id: 49292, name: 'Phường Cầu Kiệu', province_id: 2 },
    { wards_id: 49238, name: 'Phường Cầu Ông Lãnh', province_id: 2 },
    { wards_id: 49262, name: 'Phường Diên Hồng', province_id: 2 },
    { wards_id: 49273, name: 'Phường Gia Định', province_id: 2 },
    { wards_id: 49287, name: 'Phường Gò Vấp', province_id: 2 },
    { wards_id: 49221, name: 'Phường Hiệp Bình', province_id: 2 },
    { wards_id: 49264, name: 'Phường Hoà Bình', province_id: 2 },
    { wards_id: 49263, name: 'Phường Hoà Hưng', province_id: 2 },
    { wards_id: 49285, name: 'Phường Hạnh Thông', province_id: 2 },
    { wards_id: 49243, name: 'Phường Khánh Hội', province_id: 2 },
    { wards_id: 49224, name: 'Phường Linh Xuân', province_id: 2 },
    { wards_id: 49225, name: 'Phường Long Bình', province_id: 2 },
    { wards_id: 49229, name: 'Phường Long Phước', province_id: 2 },
    { wards_id: 49230, name: 'Phường Long Trường', province_id: 2 },
    { wards_id: 49267, name: 'Phường Minh Phụng', province_id: 2 },
    { wards_id: 49241, name: 'Phường Nhiêu Lộc', province_id: 2 },
    { wards_id: 49252, name: 'Phường Phú Lâm', province_id: 2 },
    { wards_id: 49293, name: 'Phường Phú Nhuận', province_id: 2 },
    { wards_id: 49256, name: 'Phường Phú Thuận', province_id: 2 },
    { wards_id: 49302, name: 'Phường Phú Thạnh', province_id: 2 },
    { wards_id: 49265, name: 'Phường Phú Thọ', province_id: 2 },
    { wards_id: 49301, name: 'Phường Phú Thọ Hoà', province_id: 2 },
    { wards_id: 49260, name: 'Phường Phú Định', province_id: 2 },
    { wards_id: 49228, name: 'Phường Phước Long', province_id: 2 },
    { wards_id: 49237, name: 'Phường Sài Gòn', province_id: 2 },
    { wards_id: 49222, name: 'Phường Tam Bình', province_id: 2 },
    { wards_id: 49288, name: 'Phường Thông Tây Hội', province_id: 2 },
    { wards_id: 49276, name: 'Phường Thạnh Mỹ Tây', province_id: 2 },
    { wards_id: 49271, name: 'Phường Thới An', province_id: 2 },
    { wards_id: 49234, name: 'Phường Thủ Đức', province_id: 2 },
    { wards_id: 49269, name: 'Phường Trung Mỹ Tây', province_id: 2 },
    { wards_id: 49298, name: 'Phường Tân Bình', province_id: 2 },
    { wards_id: 49296, name: 'Phường Tân Hoà', province_id: 2 },
    { wards_id: 49254, name: 'Phường Tân Hưng', province_id: 2 },
    { wards_id: 49253, name: 'Phường Tân Mỹ', province_id: 2 },
    { wards_id: 49303, name: 'Phường Tân Phú', province_id: 2 },
    { wards_id: 52850, name: 'Phường Tân Sơn', province_id: 2 },
    { wards_id: 49294, name: 'Phường Tân Sơn Hoà', province_id: 2 },
    { wards_id: 49300, name: 'Phường Tân Sơn Nhì', province_id: 2 },
    { wards_id: 49295, name: 'Phường Tân Sơn Nhất', province_id: 2 },
    { wards_id: 49255, name: 'Phường Tân Thuận', province_id: 2 },
    { wards_id: 49270, name: 'Phường Tân Thới Hiệp', province_id: 2 },
    { wards_id: 49283, name: 'Phường Tân Tạo', province_id: 2 },
    { wards_id: 49235, name: 'Phường Tân Định', province_id: 2 },
    { wards_id: 49299, name: 'Phường Tây Thạnh', province_id: 2 },
    { wards_id: 49226, name: 'Phường Tăng Nhơn Phú', province_id: 2 },
    { wards_id: 49242, name: 'Phường Vĩnh Hội', province_id: 2 },
    { wards_id: 49261, name: 'Phường Vườn Lài', province_id: 2 },
    { wards_id: 49240, name: 'Phường Xuân Hoà', province_id: 2 },
    { wards_id: 49244, name: 'Phường Xóm Chiếu', province_id: 2 },
    { wards_id: 49268, name: 'Phường Đông Hưng Thuận', province_id: 2 },
    { wards_id: 49291, name: 'Phường Đức Nhuận', province_id: 2 },
    { wards_id: 49315, name: 'Xã An Nhơn Tây', province_id: 2 },
    { wards_id: 49324, name: 'Xã An Thới Đông', province_id: 2 },
    { wards_id: 49327, name: 'Xã Bà Điểm', province_id: 2 },
    { wards_id: 49311, name: 'Xã Bình Chánh', province_id: 2 },
    { wards_id: 49313, name: 'Xã Bình Hưng', province_id: 2 },
    { wards_id: 49322, name: 'Xã Bình Khánh', province_id: 2 },
    { wards_id: 49307, name: 'Xã Bình Lợi', province_id: 2 },
    { wards_id: 49321, name: 'Xã Bình Mỹ', province_id: 2 },
    { wards_id: 49323, name: 'Xã Cần Giờ', province_id: 2 },
    { wards_id: 49319, name: 'Xã Củ Chi', province_id: 2 },
    { wards_id: 49331, name: 'Xã Hiệp Phước', province_id: 2 },
    { wards_id: 49326, name: 'Xã Hóc Môn', province_id: 2 },
    { wards_id: 49312, name: 'Xã Hưng Long', province_id: 2 },
    { wards_id: 49317, name: 'Xã Nhuận Đức', province_id: 2 },
    { wards_id: 49330, name: 'Xã Nhà Bè', province_id: 2 },
    { wards_id: 49320, name: 'Xã Phú Hoà Đông', province_id: 2 },
    { wards_id: 49316, name: 'Xã Thái Mỹ', province_id: 2 },
    { wards_id: 49325, name: 'Xã Thạnh An', province_id: 2 },
    { wards_id: 49318, name: 'Xã Tân An Hội', province_id: 2 },
    { wards_id: 49308, name: 'Xã Tân Nhựt', province_id: 2 },
    { wards_id: 49305, name: 'Xã Tân Vĩnh Lộc', province_id: 2 },
    { wards_id: 49304, name: 'Xã Vĩnh Lộc', province_id: 2 },
    { wards_id: 49328, name: 'Xã Xuân Thới Sơn', province_id: 2 },
    { wards_id: 49329, name: 'Xã Đông Thạnh', province_id: 2 },
  ];

  useEffect(() => {
    dispatch(fetchProvinces());
  }, []);

  useEffect(() => {
    if (provinceId) {
      dispatch(fetchWards({ provinceId }));
    }
  }, [provinceId]);

  return (
    <Form
      form={form}
      layout="vertical"
      className="lg:py-16 lg:px-24 p-16 flex flex-col items-start gap-16 self-stretch  lg:h-[550px]"
    >
      <Form.Item
        label={t('Name of address')}
        className="self-stretch"
        name={'address_name'}
        rules={[
          {
            validator: async (_, value) => {
              if (value?.length) return Promise.resolve();
              else
                return Promise.reject(
                  t('Please enter the name of the address')
                );
            },
            message: t('Please enter the name of the address'),
          },
        ]}
      >
        <InputComponent
          placeholder={t('Enter the name of the address')}
          size="large"
        />
      </Form.Item>
      <Row gutter={16} className="self-stretch">
        <Col span={12}>
          <Form.Item
            label={t('Name of recipient')}
            className="grow"
            name={'contact_name'}
            rules={[
              {
                validator: async (_, value) => {
                  if (value?.length) return Promise.resolve();
                  else
                    return Promise.reject(
                      t("Please enter the recipient's name")
                    );
                },
                message: t("Please enter the recipient's name"),
              },
            ]}
          >
            <InputComponent
              placeholder={t("Enter the recipient's name")}
              size="large"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={t('Phone number')}
            className="grow"
            name={'phone'}
            rules={[
              {
                validator: async (_, value) => {
                  if (value?.length) return Promise.resolve();
                  else
                    return Promise.reject(t('Please enter the phone number'));
                },
                message: t('Please enter the phone number'),
              },
            ]}
          >
            <InputComponent
              placeholder={t('Enter the phone number')}
              size="large"
              type="phone"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="self-stretch">
        <Col span={12}>
          <Form.Item
            label={t('Province/City')}
            className="grow"
            name={'city'}
            rules={[
              {
                validator: async (_, value) => {
                  if (!value)
                    return Promise.reject(t('Please select a province/city'));
                  if (value == fixedProvince.province_id?.toString())
                    return Promise.resolve();
                  else
                    return Promise.reject(
                      t(
                        'Currently, only addresses in Ho Chi Minh City are supported'
                      )
                    );
                },
              },
            ]}
          >
            <SelectComponent
              placeholder={t('Select')}
              size="large"
              showSearch={true}
              isLoading={provinces.isLoading}
              options={[
                ...provinces.data.map(item => ({
                  value: item.province_id?.toString(),
                  label: item.name,
                  disabled: item.province_id !== fixedProvince.province_id,
                })),
              ]}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={t('Ward/Commune')}
            className="grow"
            name={'ward'}
            rules={[
              {
                validator: async (_, value) => {
                  if (
                    newWardsHCM.some(ward => ward.wards_id.toString() === value)
                  )
                    return Promise.resolve();
                  else
                    return Promise.reject(
                      t(
                        'Currently, we only support delivery within the former Ho Chi Minh City districts (prior to the merger).'
                      )
                    );
                },
                message: t('Please select a ward/commune'),
              },
            ]}
          >
            <SelectComponent
              placeholder={t('Select')}
              size="large"
              showSearch={true}
              options={[
                ...wards.data?.map(item => ({
                  value: item.wards_id?.toString(),
                  label: item.name,
                  disabled: newWardsHCM.every(
                    ward => ward.wards_id !== item.wards_id
                  ),
                })),
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label={t('Address')}
        className="self-stretch"
        name={'street'}
        rules={[
          {
            validator: async (_, value) => {
              if (value?.length) return Promise.resolve();
              else return Promise.reject(t('Please enter a specific address'));
            },
            message: t('Please enter a specific address'),
          },
        ]}
      >
        <InputComponent
          placeholder={t('Enter a specific address')}
          size="large"
        />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        className="self-stretch"
        name={'is_default'}
      >
        <CheckboxComponent>
          <span className="text-body-medium">
            {t('Set as default address')}
          </span>
        </CheckboxComponent>
      </Form.Item>
    </Form>
  );
};

export default FormAddress;
